
    /* eslint-disable */
    // @ts-nocheck
    // @ts-ignore
    var __STORY__ = "import { useSkyNav } from '../use-sky-nav.ts';\n\nimport devices from './data/devices.json';\nimport singlePagePrototype from './example/example.twig';\n\nimport './example/example.scss';\n\nexport default {\n  title: 'Prototypes/Single Page',\n  parameters: {\n    layout: 'fullscreen',\n  },\n};\n\nexport const Example = () => {\n  useSkyNav();\n  return singlePagePrototype({\n    devices,\n  });\n};\n";
    // @ts-ignore
    var __LOCATIONS_MAP__ = {"Example":{"startLoc":{"col":23,"line":15},"endLoc":{"col":1,"line":20},"startBody":{"col":23,"line":15},"endBody":{"col":1,"line":20}}};
    
import { useSkyNav } from '../use-sky-nav.ts';

import devices from './data/devices.json';
import singlePagePrototype from './example/example.twig';

import './example/example.scss';

export default {
  title: 'Prototypes/Single Page',
  parameters: {
    layout: 'fullscreen',
  },
};

export const Example = () => {
  useSkyNav();
  return singlePagePrototype({
    devices,
  });
};



Example.parameters = { storySource: { source: "() => {\n  useSkyNav();\n  return singlePagePrototype({\n    devices,\n  });\n}" }, ...Example.parameters };